// ===== SERVIÇO DE API GENÉRICO =====

interface RequestOptions {
  method?: "GET" | "POST" | "PUT" | "DELETE";
  headers?: Record<string, string>;
  body?: any;
}

/**
 * Cliente HTTP genérico com suporte a autenticação Bearer
 */
class APIService {
  private baseURL: string;
  private token: string | null;

  constructor(baseURL: string, token?: string | null) {
    this.baseURL = baseURL;
    this.token = token || null;
  }

  private buildHeaders(customHeaders?: Record<string, string>) {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      ...customHeaders,
    };

    if (this.token) {
      headers.Authorization = `Bearer ${this.token}`;
    }

    return headers;
  }

  async request(
    endpoint: string,
    options: RequestOptions = {}
  ): Promise<any> {
    const url = `${this.baseURL}${endpoint}`;
    const response = await fetch(url, {
      method: options.method || "GET",
      headers: this.buildHeaders(options.headers),
      body: options.body ? JSON.stringify(options.body) : undefined,
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return response.json();
  }

  async get(endpoint: string) {
    return this.request(endpoint, { method: "GET" });
  }

  async post(endpoint: string, body: any) {
    return this.request(endpoint, { method: "POST", body });
  }

  async put(endpoint: string, body: any) {
    return this.request(endpoint, { method: "PUT", body });
  }

  async delete(endpoint: string) {
    return this.request(endpoint, { method: "DELETE" });
  }
}

/**
 * Cria uma instância do API Service com endpoints do dashboard
 */
export const createAPIService = (
  baseURL: string,
  token?: string | null
) => {
  const api = new APIService(baseURL, token);

  return {
    dashboardAPI: {
      getOverview: () => api.get("/api/v1/dashboard/overview"),
      getAtRiskStudents: () => api.get("/api/v1/students?at_risk=true"),
      getClasses: () => api.get("/api/v1/classes"),
      getActivities: () => api.get("/api/v1/activities"),
    },
    api,
  };
};

export default APIService;
